import script from "./AchievementChart.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementChart.vue?vue&type=script&setup=true&lang=js"

import "./AchievementChart.vue?vue&type=style&index=0&id=085eddab&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-085eddab"]])

export default __exports__